"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        key: 'inputMask',
        ignore: true,
    },
    {
        key: 'allowMultipleMasks',
        ignore: true,
    },
    {
        key: 'showWordCount',
        ignore: true
    },
    {
        key: 'showCharCount',
        ignore: true
    }
];
